module.exports = __webpack_public_path__ + "67f96b2f0df34ce53d7651ade04d1e0b.svg";